<template>
  <div class="description f">
    <img :src="img" alt="">
    <div>
      <p class="title ellipsis2">{{title}}</p>
      <p class="ellipsis">
        <span class="lable">{{$t('productDetail.color')}}：</span>{{color}}
      </p>
      <p class="ellipsis">
        <span class="lable">{{$t('productDetail.size')}}：</span>{{size}}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    img: { type: String, default: '' },
    title: { type: String, default: '' },
    color: { type: String, default: '' },
    size: { type: String, default: '' }
  }
}
</script>

<style lang="scss" scoped>
.description{
  img{
    width: 72px;
    height: 72px;
    object-fit: cover;
    border: 0.5px solid #CDD4DD;
    border-radius: 6px;
    margin-right: 10px;
    flex-shrink: 0;
  }
  div{
    padding-right: 20px;
    line-height: 142%;
    font-size: 14px;
    p{
      width: 300px;
    }
    .title{
      line-height: 15px;
      margin-bottom: 5px;
      height: 28px;
    }
    .lable{
      display: inline-block;
      width: 70px;
      text-align: right;
      color: #747A87;
      white-space: nowrap;
    }
  }
}
</style>
